import { Component, Directive, Input, ChangeDetectionStrategy } from '@angular/core';
import { BbTemplate } from '@backbase/foundation-ang/core';
import { CapabilityData } from '@backbase/identity-core-ang';

@Component({
  selector: 'bb-transaction-signing-header',
  templateUrl: 'header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionSigningHeaderComponent {
  @Input() data: CapabilityData | undefined;
  readonly hostRef = this;
}

@Directive({
  selector: '[bbTransactionSigningHeaderCustomizable]',
})
export class TransactionSigningHeaderCustomizableDirective extends BbTemplate<
  TransactionSigningHeaderComponent,
  undefined
> {}
